import React, { useContext } from "react";
import { Form, Formik } from "formik";
import { defaultValues } from "./default-values";
import { validationSchema } from "./validation-schema";
import { CUSTOMER, LEGAL_AGREEMENT, NEWSLETTER_AGREEMENT, PAYMENT_METHOD, SUBSCRIPTION_TYPE, SUPPORTERS_SUBSCRIPTION } from "./field-names";
import CustomerDataForm from "../_sub-forms/customer-data/form";
import LegalAgreementForm from "../_sub-forms/legal-agreement/form";
import NewsletterAgreementForm from "../_sub-forms/newsletter-agreement/form";
import PaymentMethodForm from "../_sub-forms/payment-method/form";
import AuthContext from "../../../services/firebase/auth-context/provider";
import SupportersAmountForm from "../_sub-forms/supporters-amount/form";
import FormSubmit from "../common/submit";
import { SubscriptionType } from "../../../util/subscription/enums";
var SubscribeWithCouponForm = function SubscribeWithCouponForm(_ref) {
    var onSubmit = _ref.onSubmit, assignedArticle = _ref.assignedArticle;
    var _useContext$ = useContext(AuthContext)[0], user = _useContext$.user, authenticated = _useContext$.authenticated; // Set default values
    defaultValues[SUBSCRIPTION_TYPE] = assignedArticle.type;
    if (authenticated && user.email)
        defaultValues[CUSTOMER].email = user.email;
    return /*#__PURE__*/ React.createElement(Formik, {
        onSubmit: onSubmit,
        initialValues: defaultValues,
        validationSchema: validationSchema
    }, function (props) {
        return /*#__PURE__*/ React.createElement(Form, null, assignedArticle.type === SubscriptionType.SUPPORTER && /*#__PURE__*/ React.createElement("div", {
            className: "mb-12"
        }, /*#__PURE__*/ React.createElement("h3", {
            className: "text-3xl mb-2"
        }, "F\xF6rderbetrag w\xE4hlen"), /*#__PURE__*/ React.createElement(SupportersAmountForm, {
            namespace: SUPPORTERS_SUBSCRIPTION
        })), /*#__PURE__*/ React.createElement("div", {
            className: "mb-12"
        }, /*#__PURE__*/ React.createElement("h3", {
            className: "text-3xl mb-2"
        }, "Pers\xF6nliche Daten"), /*#__PURE__*/ React.createElement(CustomerDataForm, {
            namespace: CUSTOMER,
            hideEmailField: authenticated && !!user.email,
            fieldValues: props.values[CUSTOMER]
        })), /*#__PURE__*/ React.createElement("div", {
            className: "mb-12"
        }, /*#__PURE__*/ React.createElement("h3", {
            className: "text-3xl mb-2"
        }, "Zahlungsart"), /*#__PURE__*/ React.createElement(PaymentMethodForm, {
            namespace: PAYMENT_METHOD,
            fieldValues: props.values[PAYMENT_METHOD]
        })), /*#__PURE__*/ React.createElement("div", {
            className: "mb-12"
        }, /*#__PURE__*/ React.createElement("h3", {
            className: "text-3xl mb-2"
        }, "Newsletter"), /*#__PURE__*/ React.createElement(NewsletterAgreementForm, {
            namespace: NEWSLETTER_AGREEMENT
        })), /*#__PURE__*/ React.createElement("div", {
            className: "mb-12"
        }, /*#__PURE__*/ React.createElement("h3", {
            className: "text-3xl mb-2"
        }, "AGB und Datenschutzverarbeitung"), /*#__PURE__*/ React.createElement(LegalAgreementForm, {
            namespace: LEGAL_AGREEMENT
        })), /*#__PURE__*/ React.createElement("div", {
            className: "mb-8"
        }, /*#__PURE__*/ React.createElement(FormSubmit, {
            text: /*#__PURE__*/ React.createElement("span", null, "Kostenpflichtig abonnieren"),
            props: props
        })));
    });
};
export default SubscribeWithCouponForm;
